import { useCallback, useMemo } from 'react';
import { useForm } from '@/js/libs/final-form/index.ts';
import { useFieldValue } from './useFieldValue.js';
export const useFieldState = (fieldName) => {
    const { change } = useForm();
    const fieldValue = useFieldValue(fieldName);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const setValue = useCallback((newValue) => change(fieldName, newValue), [change, fieldName]);
    return useMemo(() => [fieldValue, setValue], [fieldValue, setValue]);
};
